import script from "./SecurityAudit.vue?vue&type=script&setup=true&lang=js"
export * from "./SecurityAudit.vue?vue&type=script&setup=true&lang=js"

import "./SecurityAudit.vue?vue&type=style&index=0&id=ef8a886e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef8a886e"]])

export default __exports__